/* eslint-disable no-param-reassign, no-console, max-len */
import api from "../../../api";

export default {
  state: {
    config: undefined
  },
  actions: {
    async fetchStageConfig({ commit }) {
      try {
        const config = await api.get({
          url: `config.json?t=${new Date().valueOf()}`
        });
        commit("setConfig", config);
        return true;
      } catch (e) {
        console.warn(e);
        return false;
      }
    }
  },
  mutations: {
    setConfig: (state, config) => {
      state.config = config;
    }
  },
  namespaced: true
};
